import { useMutation } from "@tanstack/react-query";

import { uploadsApi } from "@/api";

/** Rasm yuklaydi va uning ommaviy manziliga yechiladi (`res.data.url`). */
export const useUploadImage = () => {
  return useMutation({
    mutationFn: (file: File) => uploadsApi.uploadImage(file),
  });
};

/** Promo/intro video yuklaydi va ommaviy manziliga yechiladi (`res.data.url`). */
export const useUploadPromoVideo = () => {
  return useMutation({
    mutationFn: (vars: { file: File; onProgress?: (p: number) => void }) =>
      uploadsApi.uploadVideo(vars.file, vars.onProgress),
  });
};
